import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(theme => ({
  feedbackGrid: {
    border: 'solid 1px rgb(112 112 112 / 11%)',
    borderRadius: 8,
    "& .k-grid-content table": {
      borderSpacing: 0
    },
    "& .k-link:hover": {
      "&:after": {
        content: 'none'
      }
    },
    "& .k-pager-wrap": {
      border: 'none',
      padding: 10
    },
    "& .k-grid-header": {
      display: 'flex !important',
    },
    "& td": {
      borderRadius: '0 !important',
      borderTop: 'none !important',
      borderLeft: 'none !important',
      verticalAlign: 'text-top',
      padding: '16px 12px',
      height: 'auto',
      "&:last-child": {
        borderRight: 'none !important',
      }
    },
  }
}));
